export * from './SymbolicSpaceService';
//# sourceMappingURL=index.js.map